import React, { Component } from 'react';
import RightSearchBar from '../components/RightSearchBar';
import MapCard from '../components/MapCard';
import SemanticTableHousing from '../components/SemanticTableHousing';
import Base from './Base';
import UserStore from "../stores/UserStore";


class ResidentialRegistry extends Component {

  constructor() {
  super();

  this.state = {
       residences: [],
       dataColumns:[
       {name:'id', prettyName: 'ID', priority: 'high'},
       {name:'address', prettyName: 'Address', priority:'high'},
       {name:'construction_year', prettyName: 'Construction year', priority:'normal'},
       {name:'home_type', prettyName: 'Home type', priority:'normal'},
       {name:'apartment_area', prettyName: 'Apartment area', priority:'normal'},
       {name:'apartment_category', prettyName: 'Apartment category', priority:'low'},
       {name:'apartment_nr', prettyName: 'Apartment nr', priority:'high'},
       {name:'area_name', prettyName: 'Area name', priority:'low'},
       {name:'building_purpose', prettyName: 'Building purpose', priority:'low'},
       {name:'building_type', prettyName: 'Building type', priority:'low'},
       {name:'county_code', prettyName: 'County code', priority:'low'},
       {name:'municipality_code', prettyName: 'Municipality code', priority:'low'},
       {name:'floor', prettyName: 'Floor', priority:'low'},
       {name:'floors', prettyName: 'Floors', priority:'low'},
       //{name:'house_nr', prettyName: 'House nr', priority:'low'},
       {name:'kitchen_type', prettyName: 'Kitchen type', priority:'low'},
       //{name:'owner_id', prettyName: 'Owner id', priority:'low'},
       {name:'ownership_type', prettyName: 'Ownership type', priority:'low'},
       {name:'postal_area', prettyName: 'Postal area', priority:'high'},
       {name:'property_key', prettyName: 'Property key', priority:'low'},
       {name:'rooms', prettyName: 'Rooms', priority:'low'},
       {name:'type_code', prettyName: 'Type code', priority:'low'}],
       markerTopic: "address",
       searchCriteria: [{name:'Address', id:0, pageClass: 'card', fields:{
         //'address':{'value':'', 'title':'Address', 'type':'text', 'placeholder':'Address'},
         'street':{'value':'', 'title':'Street', 'type':'text', 'placeholder':'Street'},
         'number':{'value':'', 'title':'Street number', 'type':'text', 'placeholder':'Street number'},
         'apartment_nr':{'value':'', 'title':'Appartment number', 'type':'text', 'placeholder':'Appartment number'},
         'letter':{'value':'', 'title':'House address letter', 'type':'text', 'placeholder':'House address letter'},
         'postal_area':{'value':'', 'title':'Postal area', 'type':'text', 'placeholder':'Postal area'},
         'postal_code':{'value':'', 'title':'Postal code', 'type':'text', 'placeholder':'Postal code'}
       }},{name:'House properties', id:1, pageClass: 'card card-collapsed' , fields:{
         /**'apartment_area_max':{'value':'', 'title':'Maximum apartment area', 'type':'text', 'placeholder':'Maximum apartment area'},
         'apartment_area_min':{'value':'', 'title':'Minimum apartment area', 'type':'text', 'placeholder':'Minimum apartment area'},
         'construction_year_max':{'value':'', 'title':'Maximum construction year', 'type':'text', 'placeholder':'Maximum construction year'},
         'construction_year_min':{'value':'', 'title':'Minimum construction year', 'type':'text', 'placeholder':'Minimum construction year'},
         'floor_max':{'value':'', 'title':'Maximum floor', 'type':'text', 'placeholder':'Maximum floor'},
         'floor_min':{'value':'', 'title':'Minimum floor', 'type':'text', 'placeholder':'Minimum floor'},
         'floors_max':{'value':'', 'title':'Maximum number of floors', 'type':'text', 'placeholder':'Maximum number of floors'},
         'floors_min':{'value':'', 'title':'Minimum number of floors', 'type':'text', 'placeholder':'Minimum number of floors'},
         'kitchen_type':{'value':'', 'title':'Kitchen type', 'type':'text', 'placeholder':'Kitchen type'},
         'living_space_max':{'value':'', 'title':'Maximum living space', 'type':'text', 'placeholder':'Maximum living space'},
         'living_space_min':{'value':'', 'title':'Minimum living space', 'type':'text', 'placeholder':'Minimum living space'},
         'rooms_max':{'value':'', 'title':'Maximum number of rooms', 'type':'text', 'placeholder':'Maximum number of rooms'},
         'rooms_min':{'value':'', 'title':'Minimum number of rooms', 'type':'text', 'placeholder':'Minimum number of rooms'},**/
         'property_key':{'value':'', 'title':'Property key', 'type':'text', 'placeholder':'Property key'},

       }}/**,{name:'House type', id:2, pageClass: 'card card-collapsed' , fields:{
         'apartment_category':{'value':'', 'title':'Category of apartment', 'type':'text', 'placeholder':'Category of apartment'},
         'building_purpose':{'value':'', 'title':'Building purpose', 'type':'text', 'placeholder':'Building purpose'},
         'ownership_type':{'value':'', 'title':'Type of ownership', 'type':'text', 'placeholder':'Type of ownership'},
         'building_type':{'value':'', 'title':'Type of building', 'type':'text', 'placeholder':'Type of building'},
       }}**/,{name:'Location', id:2, pageClass: 'card card-collapsed' , fields:{
         //'area_id':{'value':'', 'title':'Area’s id', 'type':'text', 'placeholder':'Area’s id'},
         'county_code':{'value':'', 'title':'County code', 'type':'text', 'placeholder':'County code'},
         'municipality_code':{'value':'', 'title':'Municipality code', 'type':'text', 'placeholder':'Municipality code'},
         //'parish_code':{'value':'', 'title':'Type of building', 'type':'text', 'placeholder':'Type of building'},
       }},{name:'Advanced settings', id:3, pageClass: 'card card-collapsed', fields:{
         'limit':{'value':'50', 'title':'limit', 'type':'text', 'placeholder':'limit'},
         //'owner_id':{'value':'', 'title':'Owner’s id', 'type':'text', 'placeholder':'Owner’s id'},
         'residential_ids':{'value':'', 'title':'Residential IDs', 'type':'text', 'placeholder':'residential IDs'}
       }}],
       mapPositionLat: 59.862215,
       mapPositionLng: 17.641340,
       mapZoomLevel: 13
     }
   this.makeResidentialRegistrySearch = this.makeResidentialRegistrySearch.bind(this);
   this.updateSearchCriteria = this.updateSearchCriteria.bind(this);
  }

 updateSearchCriteria(event){
   let tmp_searchCriteria = this.state.searchCriteria;
   let sectionid =event.target.attributes.getNamedItem('sectionid').value;
   tmp_searchCriteria[sectionid]['fields'][event.target.name]['value'] = event.target.value
   this.setState({searchCriteria: tmp_searchCriteria});
 }


    makeResidentialRegistrySearch = async () => {
        if (!UserStore.access_token) {
            alert("Please login first");
            return;
        }

        // Build query string manually to avoid URL encoding issues with Swedish characters
        const queryParts = [];
        this.state.searchCriteria.forEach(section => {
            Object.keys(section.fields).forEach(key => {
                const v = section.fields[key].value;
                if (!v) return;
                const field = (key === 'residential_ids') ? 'id' : key;
                // Handle field name mapping - API expects 'address' but form uses 'street'
                const apiField = (field === 'street') ? 'address' : field;
                queryParts.push(`${apiField}=${encodeURIComponent(v)}`);
            });
        });
        
        // Always add access_token to query string
        queryParts.push(`access_token=${UserStore.access_token}`);
        
        const queryString = queryParts.join('&');
        const url = `${global.apiUrl}/v1/residential/registry?${queryString}`;

        try {
            const res = await fetch(url, {
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (res.status === 401) {
                alert("Authentication failed. Please login again.");
                return;
            }

            if (!res.ok) {
                throw new Error(`HTTP ${res.status}: ${res.statusText}`);
            }

            const data = await res.json();
            const residences = data && data.residences ? data.residences : [];
            this.setState({ residences });

            if (residences[0]) {
                this.setState({
                    mapPositionLat: residences[0].wgs84lat,
                    mapPositionLng: residences[0].wgs84lon,
                    mapZoomLevel: 14
                });
            } else {
                alert("No result found for your search criteria");
            }
        } catch (error) {
            console.error('Registry search failed:', error);
            alert(`Search failed: ${error.message}`);
        }
    }

    componentDidMount() {}

    render() {
        return (
            <Base
                pageTopic={"Bostadsregistret"}
                mainContent={
                    <>
                        <MapCard
                            polylines={[[[51.505, -0.09], [51.51, -0.1], [51.51, -0.12]]]}
                            polygons={[[[51.515, -0.09], [51.52, -0.1], [51.52, -0.12]]]}
                            markers={this.state.residences}
                            lonName={"wgs84lon"}
                            latName={"wgs84lat"}
                            markerTitle={this.state.markerTopic}
                            markerPopupColumns={this.state.dataColumns}
                            mapPositionLat={this.state.mapPositionLat}
                            mapPositionLng={this.state.mapPositionLng}
                            mapZoomLevel={this.state.mapZoomLevel}
                        />
                        <SemanticTableHousing
                            title="Residences"
                            tableData={this.state.residences}
                            dataColumns={this.state.dataColumns}
                        />
                    </>
                }
                searchBar={
                    <RightSearchBar
                        searchCriteria={this.state.searchCriteria}
                        updateSearchCriteria={this.updateSearchCriteria}
                        searchFunction={this.makeResidentialRegistrySearch}
                    />
                }
            />
        );
    }
}

export default ResidentialRegistry;
